import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AnnouncementSelectSiteController } from 'fragments/announcements/interfaces';
import { useAPIAnnouncements } from 'services/announcements/api-announcements.service';
import { AdminSite } from 'services/announcements/announcements.service';

export const useAnnouncementSelectSiteController = (): AnnouncementSelectSiteController => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { getAdminSites } = useAPIAnnouncements();
    const accessToken = searchParams.get('access_token') || '';

    const [sites, setSites] = useState<AdminSite[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);

    const fetchSites = () => {
        setLoading(true);
        setError(false);
        getAdminSites(accessToken)
            .then(setSites)
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (!accessToken) {
            navigate('/mobile/404');
            return;
        }
        fetchSites();
    }, [accessToken]);

    const onSelect = (siteId: string) =>
        navigate(`/mobile/announcements/compose?access_token=${accessToken}&site_id=${siteId}&is_admin=true`);

    const onRetry = () => fetchSites();

    return {
        state: { sites: sites.map((s) => ({ siteId: s.siteId, siteName: s.siteName })), loading, error },
        events: { onSelect, onRetry },
    };
};
